
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82 37.9a74.63 74.63 0 00-8.35-10.78 36 36 0 00-8.52-6.92c-3.8-2.11-7.44-2.69-10.81-1.72a15.21 15.21 0 00-10.26 9.93c-1.53 4.3-1.84 9.28-2.14 14.09v.34c-.29 4.7-.6 9.57-1.71 13.41-1.21 4.18-3.08 6.69-6 8.12a11.79 11.79 0 01-6.22.53 39.14 39.14 0 01-8.27-2.15 73.78 73.78 0 01-9.92-4.47 2.9 2.9 0 00-2.37-.23 2.64 2.64 0 00-2 3.1 1.8 1.8 0 00.08.21 2.17 2.17 0 001 1.08 79.75 79.75 0 0010.62 4.83 44.5 44.5 0 009.48 2.44 26.07 26.07 0 003.19.22 14.6 14.6 0 006.51-1.37c4.46-2.16 7.53-6 9.12-11.54 1.26-4.37 1.56-9.18 1.85-13.82v-.8c.32-5.08.69-9.56 1.89-12.95 1.29-3.66 3-5.44 6.25-6.36 1.79-.51 4-.07 6.42 1.3a32.74 32.74 0 017.41 6.05 70.47 70.47 0 017.8 10.06 1.63 1.63 0 00.11.17 2.81 2.81 0 003.69.6 2.78 2.78 0 001.35-1.73 2.08 2.08 0 00-.2-1.64z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    